;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "FaMvp0iAYL"							}), success: c, error: e});						}, cb  = function(section, $) {window.HUB = window.HUB || {};
 
window.HUB.formatMoney = window.HUB.formatMoney ||  function(t, r) {
    function n(t, r) {
        return void 0 === t ? r : t
    }
    function e(t, r, e, o) {
        if (r = n(r, 2),
        e = n(e, ","),
        o = n(o, "."),
        isNaN(t) || null == t)
            return 0;
        var a = (t = (t / 100).toFixed(r)).split(".");
        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e) + (a[1] ? o + a[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = ""
      , a = /\{\{\s*(\w+)\s*\}\}/
      , i = r || '${{amount}}';
    switch (i.match(a)[1]) {
    case "amount":
        o = e(t, 2);
        break;
    case "amount_no_decimals":
        o = e(t, 0);
        break;
    case "amount_with_comma_separator":
        o = e(t, 2, ".", ",");
        break;
    case "amount_with_space_separator":
        o = e(t, 2, " ", ",");
        break;
    case "amount_with_period_and_space_separator":
        o = e(t, 2, " ", ".");
        break;
    case "amount_no_decimals_with_comma_separator":
        o = e(t, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        o = e(t, 0, ".", "");
        break;
    case "amount_with_space_separator":
        o = e(t, 2, ",", "");
        break;
    case "amount_with_apostrophe_separator":
        o = e(t, 2, "'", ".")
    }
    return i.replace(a, o)
};;var cb  = function($) {
	var $this = $(this),
	$dom  = $this.closest('.lh-collection-page');
	$this.find('.lh-toggle-menu').on('click', function(){
		$(this).closest('li').toggleClass('active').find('ul').toggleClass('active');
	});
	$this.on('click','.title-wrapper h3', function(){
		$(this).closest('.lh-sidebar-block').toggleClass('active').find('.lh-sidebar-block-content').slideToggle(200);
	});
	$this.on('click','.lh-overlay-sidebar', function(){
		$(this).closest('.lh-collection-page').removeClass('lh-show');
	});
	onClickTag();
	function onClickTag(){
		var size_tags = parseInt($dom.find('.lh-sidebar-content').data('sizeTags')),
				l_search  = window.location.search;
		$dom.find('.lh-sidebar-content .lh-sidebar-block[data-multi-select="false"]').each(function(){
			$(this).find('.lh-item-filter a:not(.active)').click(function(e){
				var current     = $(this),
						parent      = current.parent(),
						tag_handle  = parent.data('handle'),
						tag_active  = parent.siblings(':has(a.active)').find('a');
				if(tag_active.length){
					e.preventDefault();
					var url = (size_tags < 2) ? tag_active[0].href.replace(l_search,'') + "/" : tag_active[0].href.replace(l_search,'');
					if(!window.LAYOUTHUB_LIVE)
					window.location = url + (size_tags >= 2 ? '+':'') + tag_handle + l_search;
				}
			});
		});

	}
 };						cb.bind($('section[data-section-id="FaMvp0iAYL"] include[data-name="sidebar"][data-id="1"]').get(0))(jQuery);;var cb  = function($) {
    var $this = $(this);
    

 };						cb.bind($('section[data-section-id="FaMvp0iAYL"] include[data-name="product-items"][data-id="2"]').get(0))(jQuery);;var cb  = function($) {
  if(document.querySelector('.page-container') && window.getComputedStyle(document.querySelector('.page-container')).transform.indexOf('matrix') != -1){
    document.querySelector('.page-container').style.webkitTransform='none';
    document.querySelector('.page-container').style.transform='none';
  }
   var  $this = jQuery(this),
        _dom  = $this.find('.lh-collection-page');
      popup_sidebar = $this.find('.lh-popup-sidebar');
  $(window).resize(function(){
    if($(window).width() >= 992) {
      _dom.hasClass('lh-mobile') && _dom.removeClass('lh-mobile');
      _dom.hasClass('lh-show') && _dom.removeClass('lh-show');
    }
    else
      !_dom.hasClass('lh-mobile') && _dom.addClass('lh-mobile');
  }).trigger('resize');
  popup_sidebar.click(function(e){
    e.preventDefault();
    _dom.toggleClass('lh-show');
  });
  _dom.find('.lh-sidebar-close a , .lh-sidebar-overlay').click(function(){
    _dom.removeClass('lh-show');
  });

  $this.on('click', '.lh-sorting-btn,.lh-overlay',function(){
    $this.find('.shopify-ordering').toggleClass('active');
});
 var queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $(function() {
    $this.on('click', '.cl-select_orderby li', function(){
        if(window.LAYOUTHUB_LIVE)
        {
            console.log(queryParams);
            return;
        }
        var _this= $(this);
        queryParams.sort_by =  _this.data('value');
        location.search = jQuery.param(queryParams);
    });
  });
  initRating();
  function initRating(){
    if(!document.querySelector('#lh-fake-review') && !window.SPR && (window.LAYOUTHUB_LIVE === true || window.location.protocol === 'blob:' ))
    {
      jQuery.get('https://productreviews.shopifycdn.com/assets/v4/spr.js', function(code) {
        var regex = new RegExp(['"','/','/'].join(''),'gm');
        code = code.replace(regex, '"https://').replace(/SPR\./g,'window.SPR.').replace('window.SPR=','window.SPR=window.SPR || ');
        code = code.replace('return r=t.remote_id.toString()','if(!t.remote_id)return 0;return r=t.remote_id.toString()');
        code = code.replace('return r.fn.serializeObject','return !r || !r.fb ? false : r.fn.serializeObject');
        var blob = new Blob([code], {
          type: "application/javascript"
        });
        var url = URL.createObjectURL(blob);
        var script = document.createElement("script");
        script.src = url;
        script.id = "lh-fake-review";
        script.type = "text/javascript";
        if (!window.SPR)
        document.head.append(script);
      })
    }
    else
    {
      if(window.SPR && window.SPR.$){
        window.SPR.loadjQueryExtentions(window.SPR.$);
        window.SPR.$(document).ready(function() {
            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
        })
      }
    }
  }



 };						cb.bind($('section[data-section-id="FaMvp0iAYL"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="FaMvp0iAYL"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/e8ltYQ5NRMhsj2kw/collection/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');